import * as bootstrap from "bootstrap"

/**
 * Dispose a Bootstrap tooltip without tripping pending show/hide callbacks.
 * See https://github.com/twbs/bootstrap/issues/37474
 *
 * @param {bootstrap.Tooltip|null|undefined} tooltip
 */
function safeDisposeTooltip(tooltip) {
  if (!tooltip) return

  tooltip.dispose()
  tooltip._activeTrigger = {}
  tooltip._element = document.createElement("noscript")
}

function tooltipTitle(tooltip) {
  if (!tooltip) return ""

  if (typeof tooltip._getTitle === "function") {
    return tooltip._getTitle() || ""
  }

  const title = tooltip._config?.title
  return (typeof title === "function" ? title.call(tooltip) : title) || ""
}

function elementTooltipTitle(el) {
  return el.getAttribute("data-bs-title") || ""
}

/**
 * Initialize Bootstrap tooltips within a DOM subtree.
 * Markup convention: data-bs-toggle="tooltip" + data-bs-title (never native title).
 *
 * @param {ParentNode} [root=document] - Root element to search within
 */
export function activateTooltips(root = document) {
  const scope = root instanceof Element || root instanceof Document ? root : document

  scope.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    const desiredTitle = elementTooltipTitle(el)
    const existing = bootstrap.Tooltip.getInstance(el)

    if (existing) {
      if (tooltipTitle(existing) === desiredTitle) return

      safeDisposeTooltip(existing)
    }

    new bootstrap.Tooltip(el)
  })
}

/**
 * Dispose Bootstrap tooltip instances within a DOM subtree.
 *
 * @param {ParentNode} [root=document] - Root element to search within
 */
export function disposeTooltips(root = document) {
  const scope = root instanceof Element || root instanceof Document ? root : document

  scope.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    safeDisposeTooltip(bootstrap.Tooltip.getInstance(el))
  })
}
